/** @format */

import Popups from "./../Popups";
import Forms from "./../Forms";
import Attributes from "./Attributes";
import Messages from "./../../library/Messages";

export default class Personalise {
	constructor() {
		this.instance = self;
		this.popupsInstance = new Popups();
	}

	static init() {
		const self = new Personalise();
		self.attachEvents();
	}

	static mergeDuplicateQuantities($link) {
		const self = new Personalise();

		self.tidyTeamRows($link);
	}

	attachEvents() {
		const self = this;

		$(document).on("click", ".js-personalise-link", function (e) {
			e.preventDefault();
			let $this = $(this);

			if ($this.hasClass("mod-disabled")) {
				Messages.error($this.data("error-message"));
			} else {
				self.tidyTeamRows($this);

				setTimeout(function () {
					self.openPopup($this);
				}, 1);
			}
		});

		$(document).on("click", ".js-personalise-basket-link", function (e) {
			e.preventDefault();
			self.openBasketPopup($(this));
		});

		$(document).on(
			"ajax:request-success",
			"[data-team-personalisation-success]",
			function (event) {
				const { data } = event.detail;
				console.log("data", data);
				console.log("personalisation", data.personalisation);
				self.setTeamPersonalisations(data.personalisation);
				$(".js-personalise-link").removeClass("is-erroneous");

				$.magnificPopup.instance.close();
			}
		);

		$(document).on(
			"ajax:request-success",
			"[data-personalisation-success]",
			function (event) {
				const { data } = event.detail;
				console.log("data", data);
				console.log("personalisation", data.personalisation);
				if ($(".js-add-bundle-to-basket").length > 0) {
					$(".js-add-bundle-to-basket .js-personalisations").val(
						data.personalisation
					);
				} else {
					$(".js-add-to-basket .js-personalisations").val(data.personalisation);
				}

				$(".js-personalise-link").removeClass("is-erroneous");

				$.magnificPopup.instance.close();
			}
		);

		$(document).on("change", ".js-toggle-personalise-sizes", function () {
			let $wrapper = $(this).parents(".form-group");
			self.togglePersonaliseSizes($wrapper);
		});

		$(document).on("popupOpen", function (e, popupOptions) {
			if (popupOptions.items.src.indexOf("popups/product-personalisation") !== -1) {
				self.updatePersonalisationTotals();

				$(".page-shop-product-personalisation .js-toggle-personalise-sizes").each(
					function () {
						self.togglePersonaliseSizes($(this).parents(".form-group"));
					}
				);

				$(
					".page-shop-product-personalisation .js-personalise-type-select, .page-shop-product-personalisation .js-personalise-type-hidden"
				).each(function () {
					self.toggleCharacterRestrictions($(this));
				});
			}

			if (popupOptions.items.src.indexOf("popups/product-personalisation-quote") !== -1) {
				self.updatePersonalisationTotals();
			}
		});

		$(document).on(
			"change",
			".page-shop-product-personalisation .js-personalise-type-select",
			function () {
				self.toggleCharacterRestrictions($(this));
			}
		);

		$(document).on("click", ".js-copy-personalise-options", function (e) {
			e.preventDefault();
			self.copyPersonaliseOptions($(this).parents(".personalise-item"));
		});

		$(document).on("change", ".js-personalise-material-select", function () {
			self.updatePersonalisationTotals();
		});

		$(document).on("keyup", ".js-personalise-value-input", function () {
			self.updatePersonalisationTotals();
		});

		$(document).on("change", ".js-personalise-type-select", function () {
			self.toggleTeamDropdown($(this));
			self.setTypeCustomName($(this));
		});

		$(document).on("change", ".js-personalise-team-select", function () {
			$(this)
				.parents(".personalise-row")
				.find(".js-personalise-value-input")
				.val($(this).val());
			self.updatePersonalisationTotals();
		});
	}

	tidyTeamRows($link) {
		const self = this,
			attributesInst = new Attributes(),
			team = $link.data("team");

		if (team) {
			$(".js-product-team-quantity-stockcode").each(function () {
				let $stockcode = $(this),
					$duplicates = $(
						'.js-product-team-quantity-stockcode[value="' + $stockcode.val() + '"]'
					);

				if ($duplicates.length > 1) {
					let $quantity = $stockcode
							.parents(".js-product-team-quantity-row")
							.find(".js-product-team-quantity-input"),
						quantity = Number($quantity.val());

					$duplicates.each(function (key, $duplicate) {
						if (key > 0) {
							quantity += Number(
								$($duplicate)
									.parents(".js-product-team-quantity-row")
									.find(".js-product-team-quantity-input")
									.val()
							);

							attributesInst.removeTeamQuantityRow(
								$($duplicate).parents(".js-product-team-quantity-row")
							);
						}
					});

					$quantity.val(quantity);
				}
			});

			attributesInst.setTeamPrice();
		}

		return self;
	}

	openPopup($link) {
		const self = this,
			url = self.getCustomiseLink($link);

		self.popupsInstance.openAjaxCentralPopup(url);
	}

	openBasketPopup($link) {
		const self = this,
			url = self.getCustomiseBasketLink($link);

		self.popupsInstance.openAjaxCentralPopup(url);
	}

	getCustomiseLink($link) {
		const self = this;

		let url = $link.data("href"),
			team = $link.data("team"),
			bundle = $link.data("bundle"),
			$form = $link.parents("form");

		if (bundle) {
			let stockcodeId = $form.find('input[name="stockcode_id"]').val(),
				quantity = $form.find('input[name="quantity"]').val(),
				bundleData = decodeURIComponent(
					$form.find('.js-bundle-stockcodes input[type="hidden"]').serialize()
				),
				personalisations = $form.find('input[name="personalisations"]').val();

			url +=
				"?bundle=true&quantity=" +
				quantity +
				"&personalisations=" +
				personalisations +
				"&" +
				bundleData;
		} else if (team) {
			let formData = decodeURIComponent(
				$form.find(".js-product-team-quantity-rows :input").serialize()
			);

			url += "?team=true&" + formData;
		} else {
			let stockcodeId = $form.find('input[name="stockcode_id"]').val(),
				quantity = $form.find('input[name="quantity"]').val(),
				personalisations = $form.find('input[name="personalisations"]').val();

			url +=
				"?stockcode_id=" +
				stockcodeId +
				"&quantity=" +
				quantity +
				"&personalisations=" +
				personalisations;
		}

		return url;
	}

	getCustomiseBasketLink($link) {
		const self = this;

		let url = $link.data("href"),
			$basketItem = $link.parents(".basket-item");

		url +=
			"?basket=true&team=true&item_id=" +
			$basketItem.data("item-id") +
			($basketItem.data("bundle-instance")
				? "&bundle=true&bundle_instance=" + $basketItem.data("bundle-instance")
				: "");

		return url;
	}

	setTeamPersonalisations(data) {
		const self = this;

		$(".js-product-team-personalisations-input").val("");

		data = JSON.parse(data);

		let personalisationArray = [];
		let currentStockcodeId = 0;

		$.each(data, function (key, item) {
			$.each(item, function (stockcodeId, personalisations) {
				if (stockcodeId != currentStockcodeId) {
					personalisationArray = [];
				}

				let $stockcode = $(
					$('.js-product-team-quantity-stockcode[value="' + stockcodeId + '"]')
				);

				let $row = $stockcode.parents(".js-product-team-quantity-row"),
					$personaliseInput = $row.find(".js-product-team-personalisations-input");

				personalisationArray.push({ [stockcodeId]: personalisations });
				$personaliseInput.val(JSON.stringify(personalisationArray));

				currentStockcodeId = stockcodeId;
			});
		});
	}

	togglePersonaliseSizes($wrapper) {
		const self = this,
			$type = $wrapper.find(".js-personalise-type-select"),
			$material = $wrapper.find(".js-personalise-material-select");

		$wrapper.find(".personalise-size-dropdown").hide();
		$wrapper.find(".js-" + $material.val() + "-" + $type.val() + "-size").show();
	}

	copyPersonaliseOptions($mainItem) {
		const self = this,
			$fields = $mainItem.find(":input"),
			$wrapper = $mainItem.parents(".accordion"),
			$items = $wrapper.find(".personalise-item");

		let data = {};

		$fields.each(function () {
			if ($(this).data("field") != "value") {
				if (typeof data[$(this).data("position")] === "undefined") {
					data[$(this).data("position")] = {};
				}

				data[$(this).data("position")][$(this).data("field")] = $(this).val();
			}
		});

		$items.each(function () {
			let $item = $(this);

			if ($(this).data("index") != $mainItem.data("index")) {
				$.each(data, function (positionId, values) {
					$.each(values, function (name, value) {
						$item
							.find(
								':input[data-position="' +
									positionId +
									'"][data-field="' +
									name +
									'"]'
							)
							.val(value);

						let $select = $item.find(
							'select[data-position="' + positionId + '"][data-field="' + name + '"]'
						);
						$select.select2("destroy");
						Forms.initSelectPlugin($select);

						self.togglePersonaliseSizes($select.parents(".form-group"));
					});
				});
			}
		});
	}

	updatePersonalisationTotals() {
		const self = this,
			$form = $(".js-personalisation-form"),
			printPrice = $form.data("print-price"),
			embroideryPrice = $form.data("embroidery-price"),
			$rows = $form.find(".personalise-row");

		let total = 0;

		$rows.each(function () {
			let $row = $(this);

			if ($row.find(".js-personalise-value-input").val()) {
				if ($row.find(".js-personalise-material-select").val() == "embroidery") {
					total += parseFloat(embroideryPrice);
				} else {
					total += parseFloat(printPrice);
				}
			}
		});

		$(".js-personalisation-total").text(
			total.toFixed(2).toLocaleString(window.site.currency.locale)
		);
	}

	static calculatePersonalisationTotals(data) {
		var total = 0;

		$.each(data, function (key, item) {
			if (item.value) {
				if (item.material == "embroidery") {
					total += window.site.personalise.embroidery;
				} else {
					total += window.site.personalise.print;
				}
			}
		});

		return total.toFixed(2);
	}

	static calculateBundlePersonalisationTotals(data) {
		var total = 0;

		$.each(data, function (key, position) {
			$.each(position, function (key, item) {
				if (item.value) {
					if (item.material == "embroidery") {
						total += window.site.personalise.embroidery;
					} else {
						total += window.site.personalise.print;
					}
				}
			});
		});

		return total.toFixed(2);
	}

	static calculateTeamPersonalisationTotals(data) {
		var total = 0;

		$.each(data, function (key, row) {
			$.each(row, function (key, position) {
				$.each(position, function (key, item) {
					if (item.value) {
						if (item.material == "embroidery") {
							total += window.site.personalise.embroidery;
						} else {
							total += window.site.personalise.print;
						}
					}
				});
			});
		});

		return total.toFixed(2);
	}

	toggleCharacterRestrictions($type) {
		const self = this,
			type = $type.val(),
			$row = $type.parentsUntil(".personalise-row"),
			$input = $row.find(".js-personalise-value-input");

		$input.unbind('keypress');

		if (type == "initials" || type == 'Initials' || type == 'INITIALS') {
			$input.attr("maxlength", 4);
			$input.bind('keypress', function (event) {
				var regex = new RegExp("^[a-zA-Z]+$");
				var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
				if (!regex.test(key)) {
					event.preventDefault();
					return false;
				}
			});
		} else if (type == "number" || type == 'Number' || type == 'NUMBER') {
			$input.attr("maxlength", 4);
			$input.bind('keypress', function (event) {
				var regex = new RegExp("^[0-9]+$");
				var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
				if (!regex.test(key)) {
					event.preventDefault();
					return false;
				}
			});
		} else {
			$input.attr("maxlength", false);
		}
	}

	toggleTeamDropdown($typeSelect) {
		const self = this,
			$row = $typeSelect.parents(".personalise-row"),
			$select = $row.find(".js-personalise-team-select"),
			$selectWrapper = $row.find(".js-personalise-team-select-wrapper"),
			$input = $row.find(".js-personalise-value-input");

		$input.val("");
		$select.val("");

		$select.select2("destroy");
		Forms.initSelectPlugin($select);

		if ($typeSelect.val() == "team") {
			$selectWrapper.show();
			$input.hide();
		} else {
			$selectWrapper.hide();
			$input.show();
		}
	}

	setTypeCustomName($typeSelect) {
		const self = this,
			value = $typeSelect.val(),
			$option = $typeSelect.find('option[value="' + value + '"]'),
			customName = $option.text();

		$typeSelect.prev().val(customName);
	}
}
